import { useMediaQuery, useTheme } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import TimePeriodForm from '../../components/TimePeriodForm'
import { DateObject } from '../../helpers/date'
import { ContractInput } from '../../types/contract'
import ContractDatePicker from './ContractDatePicker'
import { ContractDetails } from './ContractDetails'
import useStyles from './styles/ContractFormStepThree.styles'

interface ContractFormStepThreeProps {
  contract: ContractInput
  setcontract: (c: ContractInput) => void
}
export const ContractFormStepThree: React.FC<ContractFormStepThreeProps> = ({
  contract,
  setcontract
}) => {
  const theme = useTheme()
  const classes = useStyles()
  const [modalIsOpen, setmodalIsOpen] = useState(true)
  const [onDoneClickForCloseDatePicker, setOnDoneClickForCloseDatePicker] =
    useState<boolean>(true)
  const [timePickerSelected, setTimePickerSelected] = useState<boolean>(false)
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const [dateObject, setdateObject] = useState<DateObject>({})
  useEffect(() => {
    setdateObject({
      gregorianEndDate: contract.To,
      gregorianStartDate: contract.From
    })
  }, [])
  useEffect(() => {
    setcontract({
      ...contract,
      From: dateObject.gregorianStartDate || '',
      To: dateObject.gregorianEndDate || ''
    })
  }, [dateObject])

  return (
    <div className={classes.root}>
      <div className={classes.datePickerContainer}>
        {!isSmall && (
          <ContractDatePicker
            onClose={() => setmodalIsOpen(false)}
            showDatePickerBox={modalIsOpen}
            dateObject={dateObject}
            setdateObject={setdateObject}
          />
        )}
      </div>
      <div className={classes.contractDetailsRoot}>
        <ContractDetails contract={contract} setcontract={setcontract} />
        {isSmall && (
          <div className={classes.datePickerContainerForMobile}>
            <TimePeriodForm
              isOpen={timePickerSelected}
              setTimePickerSelected={setTimePickerSelected}
              dateObject={dateObject}
              onChange={(data: DateObject) => {
                setdateObject(data)
              }}
              onDoneClickForCloseDatePicker={onDoneClickForCloseDatePicker}
              setOnDoneClickForCloseDatePicker={
                setOnDoneClickForCloseDatePicker
              }
              enablePastDays
            />
          </div>
        )}
      </div>
    </div>
  )
}
